<template>
  <div class="nav2Box z1200">
    <div class="top_set">
      <a href="/user?index=0">通行证首页</a>
      <span> >我的关注 </span>
    </div>
    <div class="setContent">
      <div class="leftNav">
        <p :class="currentSet==1?'activeSet':'noavtiveSet'" @click="changeSet(1)">
          <span style="padding-top: 4px;height: 56px;"><svg-icon icon-class="muflow" class="svg1" /></span><span>我的关注</span>
        </p>
        <p :class="currentSet==2?'activeSet':'noavtiveSet'" @click="changeSet(2)">
          <span style="padding-top: 2px;height: 56px;"><svg-icon icon-class="flowmu" class="svg1" /></span><span>关注我的</span>
        </p>
      </div>
      <div v-show="currentSet==1" class="rightNav">
        <div class="tips">
          我的关注
        </div>
        <div v-if="currentData.length>0">
          <div style="height: 50px;line-height: 50px;color:#666666;font-size: 14px">
            共 <span>{{ count }}</span> 条数据
          </div>
          <div class="listBox">
            <div v-for="(item,index) in currentData" :key="index" class="listBox_li">
              <div class="topmsg" :style="'background-image:url('+item.HEADIMGURL+');'">
                <div class="imgBox">
                  <img :src="item.HEADIMGURL" alt="">
                </div>
              </div>
              <div class="svgsty">
                <span class="svgsty_span" @mouseenter="hoverShow(item.UNIONID)" @mouseleave="outStyle">
                  <svg-icon icon-class="erweima" />
                </span>
                <div class="shadowIcon">
                  <img :src="currentLink" alt="">
                  <div>微信扫一扫，查看TA的主页</div>
                </div>
              </div>
              <p class="p1">
                {{ item.NICKNAME }}
              </p>
              <p class="p2">
                {{ item.SIGNATURE }}
              </p>
              <div class="btn_follwf">
                <span @click="quxiao(item)">取消关注</span>
              </div>
            </div>
          </div>
          <div class="pagina">
            <pagination :total="count" :pagesize="pagesize" :pager="pager" @pagerchange="pagerChange" />
          </div>
        </div>
        <div v-else class="nodata">
          暂无数据
        </div>
      </div>
      <div v-show="currentSet==2" class="rightNav2">
        <div class="tips">
          关注我的
        </div>
        <div v-if="currentData2.length>0">
          <div style="height: 50px;line-height: 50px;color:#666666;font-size: 14px">
            共 <span>{{ count2 }}</span> 条数据
          </div>
          <div class="listBox">
            <div v-for="(item,index) in currentData2" :key="index" class="listBox_li">
              <div class="topmsg" :style="'background-image:url('+item.HEADIMGURL+');'">
                <div class="imgBox">
                  <img :src="item.HEADIMGURL" alt="">
                </div>
              </div>
              <div class="svgsty">
                <span class="svgsty_span" @mouseenter="hoverShow(item.UNIONID)" @mouseleave="outStyle">
                  <svg-icon icon-class="erweima" />
                </span>
                <div class="shadowIcon">
                  <img :src="currentLink" alt="">
                  <div>微信扫一扫，查看TA的主页</div>
                </div>
              </div>
              <p class="p1">
                {{ item.NICKNAME }}
              </p>
              <p class="p2">
                {{ item.SIGNATURE }}
              </p>
              <div class="btn_follwf">
                <span @click="addguanzhu(item)">关注</span>
              </div>
            </div>
          </div>
          <div class="pagina">
            <pagination :total="count2" :pagesize="pagesize2" :pager="pager2" @pagerchange="pagerChange2" />
          </div>
        </div>
        <div v-else class="nodata">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import pagination from '@/components/userCenter/pagination.vue'
import { loadIndex, findPassportFollow, deletePassportFollow, findFollowPassport, addPassportFollow, isWhetherFollow, getPassportUserNewsQRcode } from '@/api/api.js'
export default {
  components: {
    pagination
  },
  inject: ['reload'],
  data() {
    return {
      codechina2: require('@/static/puyucode_chinagen.png'),
      currentData: [],
      currentData2: [],
      count: 0,
      count2: 0,
      pagesize: 6,
      pagesize2: 6,
      pager: 1,
      pager2: 1,
      currentSet: 1,
      param: {
        unionid: '',
        index: 1,
        size: 6
      },
      imgArry: [],
      currentLink: ''
    }
    // /初始化数据
  },
  mounted() {
    this.fetchData(1)
  },
  methods: {
    hoverShow(id) {
      if (!this.currentLink) {
        getPassportUserNewsQRcode({ unionid: id }).then(res => {
          this.currentLink = res.data.link
        })
      }
    },
    outStyle() {
      console.log(11)
      this.currentLink = ''
    },
    fetchData(index) {
      this.imgArry = []
      if (this.getLoca('unionid')) {
        this.param.unionid = this.getLoca('unionid')
        if (index == 1) {
          findPassportFollow(this.param).then(res => {
            this.count = res.data.count
            this.currentData = res.data.listMapData
          })
        } else {
          findFollowPassport(this.param).then(res => {
            this.currentData2 = res.data.listMapData
            this.count2 = res.data.count
          })
        }
      } else {
        loadIndex().then(res => {
          this.setloca('unionid', res.data.passportUser.unionid, 7200)
          this.param.unionid = res.data.passportUser.unionid
          if (index == 1) {
            findPassportFollow(this.param).then(res => {
              this.currentData = res.data.listMapData
              this.count = res.data.count
            })
          } else {
            findFollowPassport(this.param).then(res => {
              this.currentData2 = res.data.listMapData
              this.count2 = res.data.count
            })
          }
        })
      }
    },
    changeSet(index) {
      this.currentSet = index
      this.param.index = 1
      this.param.size = 6
      this.pager = 1
      this.pager2 = 1
      this.fetchData(index)
    },
    pagerChange(index) {
      this.pager = index
      this.param.index = index
      this.fetchData(1)
    },
    pagerChange2(index) {
      this.pager2 = index
      this.param.index = index
      this.fetchData(2)
    },
    quxiao(item) {
      if (item.UNIONID) {
        if (this.getLoca('unionid')) {
          deletePassportFollow({ unionid: this.getLoca('unionid'), targetid: item.UNIONID }).then(res => {
            if (res.data) {
              this.reload()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        } else {
          loadIndex().then(res => {
            this.setloca('unionid', res.data.passportUser.unionid, 7200)
            deletePassportFollow({ unionid: this.getLoca('unionid'), targetid: item.UNIONID }).then(res => {
              if (res.data) {
                this.reload()
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            })
          })
        }
      }
    },
    addguanzhu(item) {
      if (item.UNIONID) {
        if (this.getLoca('unionid')) {
          isWhetherFollow({ unionid: this.getLoca('unionid'), targetid: item.UNIONID }).then(res => {
            if (!res.data) {
              addPassportFollow({ unionid: this.getLoca('unionid'), targetid: item.UNIONID }).then(res => {
                if (res.data) {
                  this.$message({
                    type: 'success',
                    message: '关注成功'
                  })
                  // this.reload()
                } else {
                  this.$message({
                    type: 'error',
                    message: res.message
                  })
                }
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已关注该用户'
              })
            }
          })
        } else {
          loadIndex().then(res => {
            this.setloca('unionid', res.data.passportUser.unionid, 7200)
            isWhetherFollow({ unionid: this.getLoca('unionid'), targetid: item.UNIONID }).then(res => {
              if (!res.data) {
                addPassportFollow({ unionid: this.getLoca('unionid'), targetid: item.UNIONID }).then(res => {
                  if (res.data) {
                    this.$message({
                      type: 'success',
                      message: '关注成功'
                    })
                    this.reload()
                  } else {
                    this.$message({
                      type: 'error',
                      message: res.message
                    })
                  }
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已关注该用户'
                })
              }
            })
          })
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .z1200{
        width: 1200px;
        margin: 0 auto;
    }
    .nav2Box{
        overflow: hidden;
        min-height: 100vh;
        .top_set{
            height: 80px;
            line-height: 80px;
            text-align: left;
            font-size: 14px;
            a{
                color: #999999;
            }
            span{
                color: #666666;
            }
        }
    }
    .top_set{
        height: 80px;
        line-height: 80px;
        text-align: left;
        font-size: 14px;
        a{
            color: #999999;
        }
        span{
            color: #666666;
        }
    }
    .leftNav{
        height: 120px;
        background-color: #fff;
        width: 260px;
        display: inline-block;
        vertical-align: top;
        margin-right: 40px;
        font-size: 16px;
        svg{
            margin-right: 10px;
            font-size: 20px;
        }
        span{
            display: inline-block;
            vertical-align: top;
        }
        .svg1{
            font-size: 25px;
        }
        .noavtiveSet{
            cursor: pointer;
            height: 60px;
            line-height: 60px;
            background-color: #fff;
            padding-left: 30px;
            color: #333;
            svg{
                color: #666;
            }
        }
        .activeSet{
            cursor: pointer;
            height: 60px;
            line-height: 60px;
            background-color: #FAFCFF;
            padding-left: 30px;
            color: #E0466E;
            svg{
                color: #E0466E;
            }
        }
    }
    .rightNav{
        width: 840px;
        display: inline-block;
        vertical-align: top;
        background-color: #fff;
        padding: 0 30px;
        overflow: hidden;
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }
    }
    .rightNav2{
        overflow: hidden;
        width: 840px;
        display: inline-block;
        vertical-align: top;
        background-color: #fff;
        padding: 0 30px;
        margin-bottom: 115px;
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }

    }
    .listBox{
      margin: 10px 0;
      margin-top: -30px;
      .listBox_li{
        overflow: hidden;
        position: relative;
        height: 320px;
        width: 240px;
        display: inline-block;
        vertical-align: top;
        margin-right: 58px;
        background-color: #fff;
        text-align: center;
        border-radius: 3px;
        box-shadow: 2px 2px 2px 2px rgba(184, 184, 184, 0.5);
        margin-top: 35px;
        .svgsty{
          height: 20px;
          background-color: transparent;
          margin-bottom: 40px;
          .svgsty_span{
            font-size: 20px;
            color: #999999;
            margin-left: 200px;
            /* position: absolute; */
            margin-top: 9px;
            /*position: absolute;*/
            &:hover + .shadowIcon{
              top: 150px;
            }
          }
          .shadowIcon{
            display: inline-block;
            position: absolute;
            width: 240px;
            height: 176px;
            top: 320px;
            left: 0;
            background-color: #fff;
            transition: 1s;
            img{
              width: 100px;
              height: 100px;
              margin-top: 10px;
            }
            div{
              display: inline-block;
              height: 20px;
              width: 100%;
              margin-top: 10px;
              color: #ccc;
            }
          }
        }
        .topmsg{
          height: 100px;
          width: 100%;
          position: relative;
          background-size:2410px 1100px;
          background-repeat:no-repeat;
          .imgBox{
            height: 90px;
            width: 90px;
            background-color: #fff;
            display: inline-block;
            border-radius: 50%;
            text-align: center;
            position: absolute;
            top: 55px;
            left: 77px;
            img{
              height: 82px;
              width: 82px;
              border-radius: 50%;
              margin-top: 3px;
            }
          }
        }
        .p1{
          font-size: 18px;
          color: #333;
          text-align: center;
          height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space:nowrap;
        }
        .p2{
          margin-top: 15px;
          font-size: 14px;
          padding: 0 10px;
          height: 38px;
          color: #999999;
          text-align: center;
        }
        .btn_follwf{
          padding: 0 10px;
          margin-top: 25px;
          span{
            width: 100%;
            display: inline-block;
            background-color: #EEEEEE;
            font-size: 14px;
            color: #666;
            text-align: center;
            height: 32px;
            line-height: 32px;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }
      .listBox_li:nth-child(3n){
        margin-right: 0;
      }
    }
    .pagina{
    text-align: center;
    padding-bottom: 60px;
    padding-top: 20px;
  }
  .nodata{
    height: 300px;
    line-height: 300px;
    text-align: center;
    font-size: 30px;
    color: #999;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {

    }
</style>

